var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.state !== "READY"
    ? _c(
        "div",
        {
          staticClass: "overlay",
          class: { overlayError: _vm.state === "ERROR" },
        },
        [
          _c(
            "div",
            {
              staticClass: "overlay-container",
              style: _vm.styles.overlayContainer,
            },
            [
              _vm.state === "LOADING" || _vm.state === "UPDATING"
                ? _c(
                    "div",
                    { staticClass: "loading-container" },
                    [
                      _vm.iconToUse
                        ? _c("fa", {
                            staticClass: "spinner",
                            attrs: {
                              icon: _vm.iconToUse,
                              size: "3x",
                              spin: "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "loading-message" }, [
                        _vm._v(_vm._s(_vm.overlayMessage)),
                      ]),
                    ],
                    1
                  )
                : _vm.state === "ERROR"
                ? _c(
                    "div",
                    { staticClass: "overlay-content" },
                    [
                      _vm.iconToUse
                        ? _c("fa", {
                            staticClass: "errorIcon",
                            attrs: { icon: _vm.iconToUse, size: "2x" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.overlayMessage
                        ? _c("div", { staticClass: "overlay-message" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.overlayMessage) +
                                "\n                "
                            ),
                            _vm.showReload
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "reload-button",
                                    on: { click: _vm.reload },
                                  },
                                  [
                                    _c("fa", { attrs: { icon: "sync" } }),
                                    _vm._v(
                                      "\n                    Reload\n                "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm.message
                ? _c(
                    "div",
                    { staticClass: "overlay-message" },
                    [
                      _vm.iconToUse
                        ? _c("fa", {
                            attrs: { icon: _vm.iconToUse, size: "2x" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.message !== null
                        ? _c("div", [_vm._v(_vm._s(_vm.message))])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("default"),
                    ],
                    2
                  )
                : _c("div", [_vm._t("default")], 2),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }